/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Constants } from '../../core/Constants';
import { Document } from '../../core/models/Document';
import { Contact } from '../../core/models/common/Contact';
import { Info } from '../../core/models/common/Info';
import { DeleteNodeCommand } from './DeleteNodeCommand';

/**
 * A command used to delete the contact.
 * @author eric.wittmann@gmail.com
 * @extends DeleteNodeCommand
 * @class
 */
export class DeleteContactCommand extends DeleteNodeCommand<Contact> {
    public constructor(info? : any) {
        if(((info != null && info instanceof <any>Info) || info === null)) {
            let __args = arguments;
            super(Constants.PROP_CONTACT, info);
        } else if(info === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteNodeCommand#readNode(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} doc
     * @param {*} node
     * @return {Contact}
     */
    readNode(doc : Document, node : any) : Contact {
        let contact : Contact = doc.info.createContact();
        Library.readNode(node, contact);
        return contact;
    }
}
DeleteContactCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteContactCommand";
DeleteContactCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




